import i18n from "@/lib/i18n";
import sellerPortalEn from "@/locales/en/seller-portal.json";
import sellerPortalKy from "@/locales/ky/seller-portal.json";
import sellerPortalRu from "@/locales/ru/seller-portal.json";

export const SELLER_PORTAL_NS = "seller-portal";

export function registerSellerPortalI18n(): void {
  if (!i18n.isInitialized || typeof i18n.addResourceBundle !== "function") {
    return;
  }
  i18n.addResourceBundle("ru", SELLER_PORTAL_NS, sellerPortalRu, true, false);
  i18n.addResourceBundle("ky", SELLER_PORTAL_NS, sellerPortalKy, true, false);
  i18n.addResourceBundle("en", SELLER_PORTAL_NS, sellerPortalEn, true, false);
}

registerSellerPortalI18n();
